import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconDocumentPlus = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg width={24} height={24} className={`${className} ${sizeOption}`} >
        <path
        d="M9 13h6m-3-3v6m5 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z"
        stroke="#1C1F2B"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        />
    </svg>
  )
}